import { render } from "./TheVideoThumbnails.vue?vue&type=template&id=c1025b1e&scoped=true"
import script from "./TheVideoThumbnails.vue?vue&type=script&lang=js"
export * from "./TheVideoThumbnails.vue?vue&type=script&lang=js"

import "./TheVideoThumbnails.vue?vue&type=style&index=0&id=c1025b1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1025b1e"

export default script